/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonSearchRequest = {
    filterBy?: BabylonSearchRequest.filterBy;
    term: string;
};

export namespace BabylonSearchRequest {

    export enum filterBy {
        TRANSACTION = 'TRANSACTION',
        BLOCK = 'BLOCK',
        FINALITY_PROVIDER = 'FINALITY_PROVIDER',
        ACCOUNT = 'ACCOUNT',
        VALIDATOR = 'VALIDATOR',
        TOKEN = 'TOKEN',
        CONTRACT = 'CONTRACT',
        COVENANT_COMMITTEE = 'COVENANT_COMMITTEE',
        RELAYER = 'RELAYER',
        ALL = 'ALL',
    }


}

